import DatePresetRow from "./DatePresetRow";
import { Box } from "@mui/material";
import React from "react";

const DatePresetRows = ({ rows, isSelected, onSelect }) => (
  <Box sx={{ display: "grid", gridTemplateColumns: "max-content 1fr" }}>
    {rows.map((row, index) => (
      <DatePresetRow
        key={row.group}
        divider={index > 0}
        label={row.label}
        presets={row.presets}
        isSelected={isSelected}
        onSelect={onSelect}
      />
    ))}
  </Box>
);

export default DatePresetRows;
